/**
 * Why the WebContainer Publish control can't run right now, or `null` when it's ready.
 *
 * Publish is never hidden for this path (see `PrototyperPublishMenu`'s `unavailable` prop for
 * the one case that still hides it — the legacy, non-streaming path). When it isn't ready, this
 * explains why instead, so the control stays visible-but-disabled rather than disappearing —
 * which was the original bug report ("the publish button hidden sometimes").
 *
 * Kept dependency-free so it stays unit-testable in the node test env.
 */
export function getStreamingPublishDisabledReason(args: {
  isStreaming: boolean;
  streamLoading: boolean;
  facadeIsStreaming: boolean;
  hasUnbuiltEdits: boolean;
  buildStatus: 'idle' | 'building' | 'success' | 'error';
  hasPreviewUrl: boolean;
  previewReady: boolean;
}): string | null {
  if (args.isStreaming || args.streamLoading || args.facadeIsStreaming) {
    return 'Build in progress…';
  }
  if (args.hasUnbuiltEdits) {
    return 'You have unsaved edits — Rebuild to publish';
  }
  if (args.buildStatus !== 'success' || !args.hasPreviewUrl) {
    return 'Run Rebuild to publish';
  }
  if (!args.previewReady) {
    return 'Preview is still loading…';
  }
  return null;
}
